<div class="grid-body panel-collapse" [@panelState]="pnlState">
    <ng-content></ng-content>
</div>